import { ModalContext } from '../../../context/3cat/ModalProvider';
import { useContext } from 'react';

export const useModal = () => {
    const { openModal, modalContent, mutePlayer, setModal, removeModal, setMutePlayer, optionsModal } = useContext(ModalContext);

    return {
        openModal,
        modalContent,
        mutePlayer,
        setModal,
        removeModal,
        setMutePlayer,
        optionsModal
    };
};
